export default __webpack_public_path__ + "static/media/how-we-work.3a7ab3dd.jpg";